import React from 'react';

import { useAuthState } from '../AuthState';
import IndexedList from '../../support/shared/IndexedList';
import SignupFormModel from '../FormBuilder/SignupFormModel';
import VendorExportDialog from '../VendorList/VendorExportDialog';

import { useQueryExportDetails } from './api';

type Props = {
  isOpen: boolean;
  onClose: () => void;
};

export function ExportDialog(props: Props) {
  const { isOpen, onClose } = props;

  const { account } = useAuthState();
  const { data } = useQueryExportDetails({
    onError: (error) => {
      // eslint-disable-next-line no-console
      console.error(error);
    },
  });

  if (!data) {
    return null;
  }

  const { markets, formDef, tags } = data;

  return (
    <VendorExportDialog
      isOpen={isOpen}
      account={account}
      onHide={onClose}
      tags={tags}
      markets={new IndexedList(markets)}
      formDef={new SignupFormModel(formDef)}
    />
  );
}
